function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  fill: "currentColor"
}, React.createElement("path", {
  d: "M27.5131154,68.3293978 C24.2973822,62.5896611 22.4657913,55.9815963 22.4657913,48.9491187 C22.4657913,26.8858297 40.493988,9 62.7328956,9 C84.9718033,9 103,26.8858297 103,48.9491187 C103,71.0124077 84.9718033,88.8982374 62.7328956,88.8982374 C54.4267556,88.8982374 46.7080062,86.4031792 40.2965711,82.1273012 L23.1478032,99.276069 C19.4809968,102.942875 13.53405,102.940996 9.8631232,99.2700695 C6.19300339,95.5999497 6.19733567,89.6451775 9.85712368,85.9853895 L27.5131154,68.3293978 L27.5131154,68.3293978 Z M62.7328956,75.7642806 C77.6603816,75.7642806 89.7614999,63.7587237 89.7614999,48.9491187 C89.7614999,34.1395137 77.6603816,22.1339568 62.7328956,22.1339568 C47.8054097,22.1339568 35.7042913,34.1395137 35.7042913,48.9491187 C35.7042913,63.7587237 47.8054097,75.7642806 62.7328956,75.7642806 L62.7328956,75.7642806 Z"
})));

var SvgSearch = function SvgSearch(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 110 137.5",
    x: "0px",
    y: "0px",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSearch, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/search.d36f5532.svg";
export { ForwardRef as ReactComponent };